import { useLazyQuery } from '@apollo/client';
import { useCallback, useEffect } from 'react';
import { PREVIEW_ONBOARDING_ANSWER } from '../../services/ApolloClient/Queries';
import { config } from '../../services/Constants/AppConstants';
import { OnboardingAnswers } from '../../types/onboarding/survey';
import { SURVEY_TYPES } from '../../types/surveys';

interface PreviewOnboardingAnswerResult {
  previewOnboardingAnswer: {
    path: {
      id: string;
      name: string;
      description: string;
      image: string;
      stageId: string;
      fullyComplete: boolean;
    };
  };
}

export const usePreviewOnboardingAnswer = (
  onResult?: (data: PreviewOnboardingAnswerResult) => void,
) => {
  const [previewAnswer, { data, loading, error }] =
    useLazyQuery<PreviewOnboardingAnswerResult>(PREVIEW_ONBOARDING_ANSWER);

  const handlePreviewAnswer = useCallback(
    (answers: OnboardingAnswers) => {
      const answerString = JSON.stringify(answers);
      previewAnswer({
        variables: {
          answer: answerString,
          version: config.ONBOARDING_WEB_LATEST_VERSION,
          type: SURVEY_TYPES.ONBOARDING_WEB,
        },
      });
    },
    [previewAnswer],
  );

  useEffect(() => {
    if (data) {
      onResult?.(data);
    }
  }, [data, onResult]);

  return {
    handlePreviewAnswer,
    data,
    loading,
    error,
  };
};
